import React, { Component } from "react";
import { Table, Input, Select, Space, Form, Modal, Button } from "antd";
import { FaPencilAlt, FaBan } from "react-icons/fa";
import { BsFillLightningFill } from "react-icons/bs";
import _ from "lodash";
import { MdAddCircle } from "react-icons/md";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import DisplayControl from "../DisplayControl";
import Loadingsvg from "../common/Loadingsvg";
import utils from '../../common/utils';
import BigNumber from 'bignumber.js';
import * as yup from 'yup';
import consts, { TIME_OF_DEBOUNCE } from "../../consts";
const { Option } = Select;

const PERMISSION_CREATE_MARKET_LINK_SCREEN = "/setting/coin-setting";
const PERMISSION_UPDATE_MARKET_LINK_SCREEN = "/setting/update-coin-setting";
const PERMISSION_OPEN_MARKET_LINK_SCREEN = "/setting/coin-setting/open-market";
const PERMISSION_CLOSE_MARKET_LINK_SCREEN = "/setting/coin-setting/close-market";
const PERMISSION_UPDATE_TRANS_FEE_LINK_SCREEN = '/setting/update-limit-withdrawal';
const ALL = "ALL";
const { confirm } = Modal;

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

const tailLayout = {
  wrapperCol: {
    offset: 16,
    span: 8,
  },
};

class SettingFeeOrderTransaction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      coinName: ALL,
      visible: false,
      coin: {},
      isAddNew: false,
      pair: {},
      pair1: 'Coin',
      pair2: 'Currency',
      precision_quantity: '',
      precision_amount: '',
      precision: '',
      isLoadingSave: false,
    };
  }

  getColumns = (limits) => {
    return [
      {
        align: "center",
        title: "Thị trường",
        dataIndex: "pair",
        key: "pair",
      },
      {
        align: "center",
        title: "Phí",
        dataIndex: "fee",
        key: "fee",
      },
      {
        align: "center",
        title: "Lượng giao dịch tối thiểu",
        dataIndex: "minimum_quantity",
        key: "minimum_quantity",
      },
      {
        align: "center",
        title: "Phần thập phân",
        dataIndex: "precision",
        key: "precision",
        render: (precision) => <div>{`${precision} số thập phân`}</div>,
      },
      {
        align: "center",
        title: "Hành động",
        key: "action",
        render: (item) => (
          <Space size="middle">
            <FaPencilAlt
            title="Chi tiết"
              className="styled-icon"
              onClick={() => this.showModalDetail(item)}
            />
            {item.is_closed ? (
              <DisplayControl
                permission_link_screen={consts.AUTH.SETTING__COIN_SETTING__OPEN_MARKET__cOIN__cURRENCY}
                action={consts.CONTROLS.PUT}
              >
                <BsFillLightningFill
                title="Mở thị trường"
                  className="styled-icon"
                  onClick={() => this.showModalOpen(item.coin, item.currency)}
                />
              </DisplayControl>
            ) : (
                <DisplayControl permission_link_screen={consts.AUTH.SETTING__COIN_SETTING__CLOSE_MARKET__cOIN__cURRENCY}
                  action={consts.CONTROLS.PUT}>
                  <FaBan 
                  title="Đóng thị trường"
                    className="styled-icon"
                    onClick={() => this.showModalBan(item.coin, item.currency)}
                  />
                </DisplayControl>
              )}
          </Space>
        ),
      },
    ];
  };

  showModalDetail = (item) => {
    this.setState({
      visible: true,
      coin: { ...item },
      pair1: item.coin,
      pair2: item.currency,
      isAddNew: false,
      precision: item.precision,
      precision_quantity: item.minimum_quantity_precision,
      precision_amount: item.precision + item.minimum_quantity_precision,
    });
  };

  showModalAdd = () => {
    this.setState({
      pair1: '',
      pair2: '',
      visible: true,
      isAddNew: true,
      precision_quantity: '',
      precision_amount: '',
      precision: '',
      coin: {},
    });
  };

  handleCancelSave = (func, delay) => {
    var debounce_func = _.debounce(() => {
      func()
    }, delay)

    debounce_func()
  }

  handleCancel = () => {
    this.setState({
      visible: false,
      isLoadingSave: false,
      precision_quantity: '',
      precision_amount: '',
      precision: ''
    });

  };

  onFilterCoin = (coinName) => {
    this.setState({ coinName });
  };

  showOption = () => {
    return _.map(this.props.coinSettings || [], (item, index) => {
      return (
        <Option key={index} value={item.pair}>
          {item.pair}
        </Option>
      );
    });
  };

  showPrecision = () => {
    let arr = [0, 1, 2, 3, 4, 5, 6, 7, 8];
    return arr.map((item, index) => {
      return (
        <Option key={index} value={item}>
          {`${item} số thập phân `}
        </Option>
      );
    });
  };

  showCoin = () => {
    return _.map(_.values(this.props.coins) || [], (item, index) => {
      return (
        <Option key={index} value={item.coin}>
          {item.coin}
        </Option>
      );
    });
  };

  getData = () => {
    if (this.state.coinName === ALL) {
      return [...this.props.coinSettings] || [];
    }
    return this.props.objCoinSettings[this.state.coinName]
      ? [this.props.objCoinSettings[this.state.coinName]]
      : [];
  };


  onSubmit = () => {
    const { coin } = this.state;

    coin.minimum_quantity = parseFloat(coin.minimum_quantity);
    coin.minimum_amount = parseFloat(coin.minimum_amount);
    coin.fee = parseFloat(coin.fee);
    coin.minimum_quantity_precision = new BigNumber(10).pow(-this.state.precision_quantity).toNumber();
    coin.minimum_amount_precision = new BigNumber(10).pow(-this.state.precision_amount).toNumber();
    coin.precision = new BigNumber(10).pow(-this.state.precision).toNumber();
    this.setState({
      isLoadingSave: true
    })
    if (this.state.isAddNew) {
      this.handleCancelSave(() => {
        this.props.onCreateMarket({
          ...coin,
          coin: this.state.pair1,
          currency: this.state.pair2,
        }, () => this.setState({
          visible: false,
          isLoadingSave: false,
          precision_quantity: '',
          precision_amount: '',
          precision: ''
        }));
      }, TIME_OF_DEBOUNCE);

    } else {
      this.handleCancelSave(() => {
        this.props.onChangeSettingFeeTransactionAction({
          ...coin,
          coin: this.state.pair1,
          currency: this.state.pair2,
        }, () => this.setState({
          visible: false,
          isLoadingSave: false,
          precision_quantity: '',
          precision_amount: '',
          precision: ''
        }));
      }, TIME_OF_DEBOUNCE)
    }


  };

  onChange1 = (event) => {
    this.setState(
      {
        pair1: event,
      },
    );
  };

  onChange2 = (event) => {
    this.setState(
      {
        pair2: event,
      },
    );
  };

  onChangeFee = (event) => {
    let checkQuantity = _.get(this.state.coin, "minimum_quantity")
    let minimum_amount = utils.trimRightZeroAndDot(new BigNumber(event.target.value).times(checkQuantity).toFixed(8))
    this.setState({
      coin: {
        ...this.state.coin,
        fee: event.target.value,
        minimum_amount: checkQuantity ? minimum_amount : '',
      }
    })
  }

  onChangeQuantity = (event) => {
    let checkFee = _.get(this.state.coin, "fee")
    let minimum_amount = utils.trimRightZeroAndDot(new BigNumber(event.target.value).times(checkFee).toFixed(8))
    this.setState({
      coin: {
        ...this.state.coin,
        minimum_quantity: event.target.value,
        minimum_amount: checkFee ? minimum_amount : '',
      }
    })
  }

  onChangeAmount = (event) => {
    let checkFee = _.get(this.state.coin, "fee")
    let minimum_quantity = utils.trimRightZeroAndDot(new BigNumber(event.target.value).div(checkFee).toFixed(8))
    this.setState({
      coin: {
        ...this.state.coin,
        minimum_amount: event.target.value,
        minimum_quantity: checkFee ? minimum_quantity : '',
      }
    })
  }

  onChangePrecisionQuantity = (value) => {
    let precision_amount = value + this.state.precision
    this.setState({ 
      precision_quantity: value,
      precision_amount
    });
  }

  onChangePrecisionAmount = (value) => {
    // this.setState({ precision_amount: this.state.precision_quantity + this.state.precision });
  }

  onChangePrecision = (value) => {
    let precision_amount = value + this.state.precision_quantity
    this.setState({ 
      precision: value,
      precision_amount
    });
  }

  showModalBan = (coin, currency) => {
    const closeMarket = this.props.closeMarket;

    confirm({
      title: `Bạn có chắc chắn muốn tạm ngừng thị trường ${coin}/${currency} ?`,
      icon: <ExclamationCircleOutlined />,
      // content: 'Some descriptions',
      okText: "Đóng thị trường",
      okType: "danger",
      cancelText: "Hủy",
      onOk() {
        closeMarket({
          coin,
          currency,
        });
      },
    });
  };

  showModalOpen = (coin, currency) => {
    const openMarket = this.props.openMarket;

    confirm({
      title: `Bạn có chắc chắn muốn mở lại thị trường ${coin}/${currency} ?`,
      icon: <ExclamationCircleOutlined />,
      // content: 'Some descriptions',
      okText: "Mở thị trường",
      okType: "danger",
      cancelText: "Hủy",
      onOk() {
        openMarket({
          coin,
          currency,
        });
      },
    });
  };

  render() {
    const { visible, coin, isAddNew, pair1, pair2 } = this.state;
    const { Option } = Select;
    return (
      <div className="withdrawalHistory">
        <h3> Quản lý giao dịch </h3>
        <div className='d-flex space-between'>
          <div className="transaction">
            <span style={{ marginRight: 8 }}> Đồng: </span>
            <Select
              defaultValue={ALL}
              style={{
                width: 120,
                marginRight: 14,
              }}
              onChange={this.onFilterCoin}
            >
              <Option value={ALL}>Tất cả</Option>
              {this.showOption()}
            </Select>
          </div>
          <DisplayControl
            permission_link_screen={PERMISSION_CREATE_MARKET_LINK_SCREEN}
            action="POST"
          >
          <div>
            <Button className="d-flex align-items" onClick={this.showModalAdd}>
              <MdAddCircle size="20" className="styled-icon" />
              <span style={{ marginLeft: 4 }}> Thêm thị trường </span>
            </Button>
          </div>
          </DisplayControl>
        </div>
        <Table
          columns={this.getColumns()}
          dataSource={this.getData()}
          bordered
        />
        <Modal
          title={
            isAddNew ? "Thêm quản lý thị trường" : "Sửa quản lý thị trường"
          }
          visible={visible}
          footer={null}
          onCancel={this.handleCancel}
          width={600}
        >
          {isAddNew ? (
            <Form {...layout}>
              <div
                className="d-flex justify-evenly align-items mb-medium"
              >
                <div>
                  <span className="bold">Đồng</span>
                  <Select
                    style={{
                      width: 130,
                      marginLeft: 10,
                    }}
                    onChange={this.onChange1}
                  >
                    {this.showCoin()}
                  </Select>
                </div>
                <div>
                  <span className="bold">Tiền</span>
                  <Select
                    style={{
                      width: 130,
                      marginLeft: 10,
                    }}
                    onChange={this.onChange2}
                  >
                    {this.showCoin()}
                  </Select>
                </div>
              </div>
              <Form.Item label="Thị trường" labelAlign={"left"}>
                <div>
                  {pair1 !== pair2 ? (
                    <span>{`${pair1} / ${pair2}`}</span>
                  ) : (
                      <span> Đồng không được trùng với tiền </span>
                    )}
                </div>
              </Form.Item>
              <Form.Item label="Phí" labelAlign={"left"}>
                <Input
                  type="text"
                  name="fee"
                  value={coin.fee}
                  onChange={this.onChangeFee}
                />
              </Form.Item>
              <Form.Item label="Lượng giao dịch tối thiểu" labelAlign={"left"}>
                <Input
                  type="text"
                  name="minimum_quantity"
                  value={coin.minimum_quantity}
                  onChange={this.onChangeQuantity}
                />
              </Form.Item>
              <Form.Item label="Tổng giao dịch tối thiểu" labelAlign={"left"}>
                <Input
                  type="text"
                  name="minimum_amount"
                  value={coin.minimum_amount}
                  onChange={this.onChangeAmount}
                />
              </Form.Item>

              <Form.Item
                label="Phần thập phân"
                labelAlign={"left"}
                value={this.state.precision}
              >
                <Select
                  name="precision"
                  onChange={this.onChangePrecision}
                  value={this.state.precision}
                >
                  {this.showPrecision()}
                </Select>
              </Form.Item>
              <Form.Item label="Phần thập phân số lượng" labelAlign={"left"}>
                <Select
                  name="minimum_quantity_precision"
                  onChange={this.onChangePrecisionQuantity}
                  value={this.state.precision_quantity}
                >
                  {this.showPrecision()}
                </Select>
              </Form.Item>
              <Form.Item label="Phần thập phân tổng" labelAlign={"left"}>
                <Select
                  name="minimum_amount_precision"
                  onChange={this.onChangePrecisionAmount}
                  value={this.state.precision_amount}
                  disabled
                >
                  {this.showPrecision()}
                </Select>
              </Form.Item>
              <Form.Item
                {...tailLayout}
                style={{ marginBottom: "12px" }}
                className="text-right"
              >
                <Button
                  type="primary"
                  onClick={this.handleCancel}
                  style={{ width: "64px" }}
                >
                  Hủy
                </Button>
                <DisplayControl permission_link_screen={consts.AUTH.SETTING__UPDATE_COIN_SETTING}
                  action={consts.CONTROLS.POST}>
                  {pair1 !== pair2 && coin.minimum_quantity && coin.minimum_amount && coin.fee && this.state.precision_quantity !== '' && this.state.precision_amount !== '' && this.state.precision !== '' ?
                    (<Button type="primary" htmlType="submit" style={{ marginLeft: 12, width: "64px" }}

                      icon={<Loadingsvg name='bars'
                        hidden={!this.state.isLoadingSave} size={25} />} onClick={this.onSubmit}>
                      {this.state.isLoadingSave === false ? 'Lưu' : ''}
                    </Button>) :
                    (<Button type="primary" htmlType="submit" style={{
                      marginLeft: 12,
                      width: '64px'
                    }} disabled>
                      Lưu
                    </Button>
                    )}
                </DisplayControl>
              </Form.Item>
            </Form>
          ) : (
              <Form {...layout}>
                <Form.Item label="Thị trường" labelAlign={"left"}>
                  <Input value={`${pair1} / ${pair2}`} disabled />
                </Form.Item>
                <Form.Item label="Phí" labelAlign={"left"}>
                  <Input
                    type="text"
                    name="fee"
                    value={coin.fee}
                    onChange={this.onChangeFee}
                  />
                </Form.Item>
                <Form.Item label="Lượng giao dịch tối thiểu" labelAlign={"left"}>
                  <Input
                    type="text"
                    name="minimum_quantity"
                    value={coin.minimum_quantity}
                    onChange={this.onChangeQuantity}
                  />
                </Form.Item>
                <Form.Item label="Tổng giao dịch tối thiểu" labelAlign={"left"}>
                  <Input
                    type="text"
                    name="minimum_quantity"
                    value={coin.minimum_amount}
                    onChange={this.onChangeAmount}
                  />
                </Form.Item>

                <Form.Item label="Phần thập phân" labelAlign={"left"}>
                  <Select
                    name="precision"
                    onChange={this.onChangePrecision}
                    value={this.state.precision}
                  >
                    {this.showPrecision()}
                  </Select>
                </Form.Item>
                <Form.Item label="Phần thập phân số lượng" labelAlign={"left"}>
                  <Select
                    name="minimum_quantity_precision"
                    onChange={this.onChangePrecisionQuantity}
                    value={this.state.precision_quantity}
                  >
                    {this.showPrecision()}
                  </Select>
                </Form.Item>
                <Form.Item label="Phần thập phân tổng" labelAlign={"left"}>
                  <Select
                    name="minimum_amount_precision"
                    onChange={this.onChangePrecisionAmount}
                    value={this.state.precision_amount}
                    disabled
                  >
                    {/* {this.showPrecision()} */}
                    <Option key='1' value={this.state.precision_amount}>{`${this.state.precision_amount} số thập phân`}</Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  {...tailLayout}
                  style={{ marginBottom: "12px" }}
                  className="text-right"
                >
                  <Button
                    type="primary"
                    onClick={this.handleCancel}
                    style={{ width: "64px" }}
                  >
                    Hủy
                </Button>
                  <DisplayControl
                    permission_link_screen={PERMISSION_UPDATE_MARKET_LINK_SCREEN}
                    action="POST"
                  >

                    <Button type="primary" htmlType="submit" style={{ marginLeft: 12, width: "64px" }}

                      icon={<Loadingsvg name='bars'
                        hidden={!this.state.isLoadingSave} size={25} />} onClick={this.onSubmit}>
                      {this.state.isLoadingSave === false ? 'Lưu' : ''}
                    </Button>
                  </DisplayControl>
                </Form.Item>
              </Form>
            )}
        </Modal>
      </div>
    );
  }
}

export default SettingFeeOrderTransaction;
